// look at invoice charges to see if there is a refund
const formatStatus = ({ status, charges, latestCharge }) => {
	let statusLabel = '';
	const chargeData = [];

	if (charges && Array.isArray(charges.data)) {
		chargeData.push(...charges.data);
	}

	if (
		latestCharge &&
		typeof latestCharge === 'object' &&
		!Array.isArray(latestCharge)
	) {
		chargeData.push(latestCharge);
	}

	if (chargeData.length > 0) {
		const uniqueCharges = chargeData.filter(
			(charge, index, arr) =>
				arr.findIndex((item) => item.id === charge.id) === index
		);

		const refunded = uniqueCharges.map((item) => item.refunded);
		const containsRefunded = refunded.filter((item) => item === true);
		const isRefunded = containsRefunded.length > 0;

		if (isRefunded) {
			return 'Refunded';
		}

		const partiallyRefunded = uniqueCharges.map(
			(item) => item.amount_refunded
		);
		const containsPartiallyRefunded = partiallyRefunded.filter(
			(item) => item > 0
		);
		const isPartiallyRefunded = containsPartiallyRefunded.length > 0;

		if (isPartiallyRefunded) {
			return 'Partial Refund';
		}
	}

	switch (status) {
		case 'requires_source':
		case 'requires_payment_method':
		case 'requires_confirmation':
		case 'requires_action':
		case 'processing':
		case 'requires_capture':
			statusLabel = 'Sent';
			break;
		case 'canceled':
			statusLabel = 'Canceled';
			break;
		case 'succeeded':
			statusLabel = 'Paid';
			break;
		default:
			break;
	}

	return statusLabel;
};

export default formatStatus;
